import { render, staticRenderFns } from "./AdminViewClientModal.vue?vue&type=template&id=05d18cf8"
import script from "./AdminViewClientModal.vue?vue&type=script&lang=js"
export * from "./AdminViewClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports